import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";

import { qrListPickerValidations, qrNameValidation } from "./shared";
import { I_QREditorFormTemplate } from "@/data/types/pages";
import { TFunction } from "i18next";

export const qrCouponValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "infoHeadline",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("infoHeadline", "required", data),
        },
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("infoHeadline", "maxLength", data),
        },
        minLength: {
          value: 1,
          message: getRuleErrorMessage("infoHeadline", "minLength", data),
        },
      },
    },
    {
      name: "infoDescription",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("infoDescription", "maxLength", data),
        },
      },
    },
    {
      name: "infoSalesBadge",
      rules: {
        maxLength: {
          value: 15,
          message: getRuleErrorMessage("infoSalesBadge", "maxLength", data),
        },
      },
    },
    {
      name: "infoButtonText",
      rules: {
        maxLength: {
          value: 20,
          message: getRuleErrorMessage("infoButtonText", "maxLength", data),
        },
      },
    },
    {
      name: "couponName",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("couponName", "required", data),
        },
        maxLength: {
          value: 15,
          message: getRuleErrorMessage("couponName", "maxLength", data),
        },
        minLength: {
          value: 1,
          message: getRuleErrorMessage("couponName", "minLength", data),
        },
      },
    },
    {
      name: "couponTermsAndConditions",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("couponTermsAndConditions", "maxLength", data),
        },
      },
    },
    {
      name: "couponUrlLink",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("couponUrlLink", "pattern", data),
        },
      },
    },
    {
      name: "locationAddress",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("locationAddress", "maxLength", data),
        },
      },
    },
    {
      name: "locationNumeration",
      rules: {
        maxLength: {
          value: 40,
          message: getRuleErrorMessage("locationNumeration", "maxLength", data),
        },
      },
    },
    {
      name: "locationPostalCode",
      rules: {
        maxLength: {
          value: 40,
          message: getRuleErrorMessage("locationPostalCode", "maxLength", data),
        },
      },
    },
    {
      name: "locationCity",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("locationCity", "maxLength", data),
        },
      },
    },
    {
      name: "locationState",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("locationState", "maxLength", data),
        },
      },
    },
    {
      name: "locationCountry",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("locationCountry", "maxLength", data),
        },
      },
    },
    ...qrListPickerValidations("social_invalid", t),
  ];
};
